import Vue from "vue";
import VueRouter from "vue-router";
'use strict';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import("../views/goods_main.vue"),
    meta: "积分商城"
  },
  {
    path: "/goods_detail",
    name: "goods_detail",
    component: () =>
      import("../views/goods_detail.vue"),
    meta: ""
  },
  {
    path: "/order_list",
    name: "order_list",
    component: () =>
      import("../views/order_list.vue"),
    meta: "我的订单"
  },
  {
    path: "/order_detail",
    name: "order_detail",
    component: () =>
      import("../views/order_detail.vue"),
    meta: "订单详情"
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: () => import("../views/address/addAddress.vue")
  },

  {
    path: '/chooseAddress',
    name: 'chooseAddress',
    component:() =>import("../views/address/chooseAddress.vue")
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    component: () => import('../views/orderConfirm.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/integral_rules',
    name: 'integral_rules',
    component: () => import('../views/integral_rules.vue'),
  },
  {
    path: '/photography_show',
    name: 'photography_show',
    component: () => import('../views/photography_show/photography_show.vue'),
    meta: '影展首页',
  },
  {
    path: '/photography_exhibition',
    name: 'photography_exhibition',
    component: () => import('../views/photography_show/photography_exhibition.vue'),
    meta: '图集列表页',
  },
  {
    path: '/photography_collection',
    name: 'photography_collection',
    component: () => import('../views/photography_show/photography_collection.vue'),
    meta: '影展大图页',
  },
  {
    path: '/information_collection',
    name: 'information_collection',
    component: () => import('../views/information_collection/information_collection_main.vue'), 
    meta: '个人信息收集清单'
  },
  {
    path: '/information_collection/personal_details',
    name: 'personal_details',
    component: () => import('../views/information_collection/personal_details.vue'),
    meta: '个人信息收集清单详情',
  },
  {
    path: '/information_collection/check_rests',
    name: 'check_rests',
    component: () => import('../views/information_collection/check_rests_info.vue'),
    meta: '查看其他信息',
  },
  {
    path: '/domain-info',
    name: 'domain_info',
    component: () => import('../views/domain_info.vue'),
    meta: 'domain测试页面'
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/billing/center",
  routes,
});

export default router;

